import { render, staticRenderFns } from "./ClientNotes.vue?vue&type=template&id=9a6ac8d2"
import script from "./ClientNotes.vue?vue&type=script&lang=ts"
export * from "./ClientNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports